import styled from "styled-components"
import { maxWidth, transparentize } from "utils"
import CloudinaryImage from "components/cloudinary-image"

export const SlideContent = styled.section`
  display: ${({ hideOnPageLoad }) => (hideOnPageLoad ? "none" : "flex")};
  align-items: center;
  justify-content: space-between;
  height: 100%;
  padding: 8.8rem 17rem;

  ${(props) =>
    props.theme.component.isNested &&
    `
    padding: 8.8rem calc(12.5% + 9.6rem);
  `}

  ${maxWidth.desktop`
    padding: 8.8rem 12.5rem;

    ${(props) =>
      props.theme.component.isNested &&
      `
      padding: 8.8rem calc(10% + 6rem);
    `}
  `}

  ${maxWidth.tablet`
    flex-direction: column;
    justify-content: flex-start;
  `}

  ${maxWidth.mobile`
    padding: 0;
  `}

  color: ${(props) => props.theme.component.text};
  background: ${(props) => props.theme.component.background};
`

export const Left = styled.div`
  flex: 0 0 55%;
  ${(props) => props.theme.component.isNested && `flex: 0 0 50%;`}
  position: relative;
  padding-top: 5rem;

  ${maxWidth.tablet`
    flex: 1 0 auto;
  `}

  ${maxWidth.mobile`
    padding: 3rem 3rem 3rem 7rem;
  `}

  ::before {
    font-family: Georgia, "Times New Roman", Times, serif;
    content: "\\201C";
    font-weight: bold;
    font-size: 19rem;
    color: ${(props) => transparentize(0.88, props.theme.component.text)};

    position: absolute;
    top: -0.5rem;
    left: -11rem;

    ${maxWidth.mobile`
      left: 1rem;
      top: 0.7rem;
      font-size: 10rem;
    `}
  }

  blockquote {
    font-size: 3.6rem;
    line-height: 5rem;
    font-style: italic;
    font-weight: 500;

    em,
    strong {
      color: ${(props) => props.theme.component.highlight};
      font-style: inherit;
    }
  }

  h3 {
    font-size: 3.4rem;
    line-height: 4.6rem;
    color: #767676;

    ${(props) =>
      props.theme.component.isDarkBackground &&
      `
      color: rgba(255, 255, 255, 0.8);
    `}
  }

  h5 {
    font-size: 1.4rem;
    line-height: 1.9rem;
    color: #767676;
    text-transform: uppercase;
    margin: 1rem 0;

    ${(props) =>
      props.theme.component.isDarkBackground &&
      `
      color: rgba(255, 255, 255, 0.8);
    `}
  }

  p {
    font-size: 1.8rem;
    line-height: 2.4rem;
  }

  p::before {
    content: "“";
  }

  p::after {
    content: "”";
  }
`

export const Right = styled.div`
  flex: 0 0 40%;

  ${maxWidth.tablet`
    width: 60%;
  `}

  ${maxWidth.mobile`
    width: 100%;
  `}
`

export const Image = styled(CloudinaryImage)`
  padding-bottom: 100%;

  img {
    background: rgba(0, 0, 0, 0.04);
    border-radius: 50%;

    ${maxWidth.mobile`
      border-radius: 0;
    `}
  }
`
